<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>日志管理</el-breadcrumb-item>
        </el-breadcrumb>

        <el-card class="box-card">
            <el-form :inline="true" :model="logsForm" class="demo-form-inline">
                <el-form-item label="">
                    <el-input v-model="logsForm.menuName" @keyup.enter.native="clicksearch" placeholder="请输入菜单名称"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-input v-model="logsForm.name" @keyup.enter.native="clicksearch" placeholder="请输入操作员姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clicksearch">查询</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表 -->
            <el-table v-loading="loading" :data="logList" border stripe>
                <el-table-column prop="menuname" label="菜单名称"></el-table-column>
                <el-table-column prop="info" label="备注信息" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="adminname" label="操作员"></el-table-column>
                <el-table-column prop="adminip" label="操作员IP"></el-table-column>
                <el-table-column prop="jigouname" label="操作员机构"></el-table-column>
                <el-table-column prop="createtime" label="操作时间"></el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pages">
                <el-pagination
                @current-change="handleCurrentPageChange"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="listnum"
                :current-page.sync="selectedPageNo">
                </el-pagination>
            </div>

        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyLogs',
  data () {
    return {
      loading: false,
      logsForm: {
        menuName: '',
        name: ''
      },
      logList: [],
      selectedPageNo: 1,
      listnum: 0
    }
  },
  mounted () {
    this.apigetloglist(1, '', '')
    this.apigetlognum('', '')
  },
  methods: {
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetloglist(this.selectedPageNo, this.logsForm.menuName, this.logsForm.name)
      this.apigetlognum(this.logsForm.menuName, this.logsForm.name)
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetloglist(this.selectedPageNo, this.logsForm.menuName, this.logsForm.name)
      this.apigetlognum(this.logsForm.menuName, this.logsForm.name)
    },
    apigetlognum: function (kwdmenuname, kwdusername) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        kwdmenuname: kwdmenuname,
        kwdusername: kwdusername
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getlognum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listnum = response.data.Num
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetloglist: function (pageno, kwdmenuname, kwdusername) {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: pageno,
        kwdmenuname: kwdmenuname,
        kwdusername: kwdusername
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getloglist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.logList = []
            response.data.List.filter((item1, i1) => {
              that.logList.push({ id: item1.Id, menuname: item1.Menuname, info: item1.Info, adminname: item1.Adminname, adminip: item1.Adminip, jigouname: item1.Jigouname, createtime: item1.Createtime })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
